import * as actionTypes from "../actionTypes";

const initialState = {
  is_error: false,
  register_details: [],
  user_details: null,
  tax_year_res: null,
  tax_end_date_res: null,
  tax_end_date_start_from: 1,
  run_tax_end_date_api: null,
  labor_setting_essentials: null,
  setup_wizard_details: [],
  states: null,
  upload_staff: null,
  upload_payee: null,
  user_token: "",
  is_registered: false,
};

const authReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case actionTypes.GET_REGISTER_DETAILS_FAILED:
    case actionTypes.SAVE_REGISTER_DETAILS_FAILED:
    case actionTypes.SAVE_LOGIN_DETAILS_FAILED:
    case actionTypes.SAVE_FORGOT_DETAILS_FAILED:
    case actionTypes.GET_SETUP_DETAILS_FAILED:
    case actionTypes.GET_STARTED_DETAILS_FAILED:
    case actionTypes.SAVE_REQUEST_API_FAILED:
    case actionTypes.GET_PROFILE_DETAILS_FAILED:
    case actionTypes.GET_ACCRUAL_TYPE_FAILED:
      return {
        ...state,
        is_error: true,
      };
    case actionTypes.GET_REGISTER_DETAILS_SUCCEEDED:
    case actionTypes.SAVE_REGISTER_DETAILS_SUCCEEDED:
    case actionTypes.SAVE_LOGIN_DETAILS_SUCCEEDED:
    case actionTypes.SAVE_FORGOT_DETAILS_SUCCEEDED:
    case actionTypes.GET_SETUP_DETAILS_SUCCEEDED:
    case actionTypes.GET_STARTED_DETAILS_SUCCEEDED:
    case actionTypes.SAVE_REQUEST_API_SUCCEEDED:
    case actionTypes.GET_PROFILE_DETAILS_SUCCEEDED:
    case actionTypes.CHECK_TAX_YEAR_SUCCEEDED:
    case actionTypes.GET_TAX_END_DATE_SUCCEEDED:
    case actionTypes.SAVE_UPLOAD_STAFF_SUCCEEDED:
    case actionTypes.SAVE_UPLOAD_PAYEE_SUCCEEDED:
    case actionTypes.GET_STATE_SUCCEEDED:
      return {
        ...state,
        ...payload,
        is_error: false,
      };
    case actionTypes.CHECK_TAX_YEAR_FAILED:
      return {
        ...state,
        is_error: true,
        tax_year_res: null,
      };
    case actionTypes.GET_STATE_FAILED:
      return {
        ...state,
        is_error: true,
        states: null,
      };
    case actionTypes.GET_TAX_END_DATE_FAILED:
      return {
        ...state,
        is_error: true,
        tax_end_date_res: null,
      };
    case actionTypes.GET_ACCRUAL_TYPE_SUCCEEDED:
      return {
        ...state,
        labor_setting_essentials: payload,
      };
    case actionTypes.SAVE_UPLOAD_STAFF_FAILED:
      return {
        ...state,
        upload_staff: null,
      };
    case actionTypes.SAVE_UPLOAD_PAYEE_FAILED:
      return {
        ...state,
        upload_payee: null,
      };
    case actionTypes.INITIAL_REGISTER_DETAILS:
      return {
        ...state,
        register_details: null,
        is_registered: false,
      };
    case actionTypes.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default authReducer;
